import i18n from '@/utils/i18n';

const fields =
    {
        partner: {
            items: [
                {
                    label: i18n.t('users.email'),
                    placeholder: i18n.t('users.email'),
                    required: true,
                    type: 'email',
                    name: 'email'
                },
                {
                    label: i18n.t('users.password'),
                    placeholder: i18n.t('users.password'),
                    required: true,
                    toggled: false,
                    type: 'password',
                    name: 'password'
                },
                {
                    label: i18n.t('users.first_name'),
                    placeholder: i18n.t('users.first_name'),
                    required: true,
                    type: 'text',
                    name: 'first_name'
                },
                {
                    label: i18n.t('users.last_name'),
                    placeholder: i18n.t('users.last_name'),
                    required: true,
                    type: 'text',
                    name: 'last_name'
                },
                {
                    label: i18n.t('users.company'),
                    placeholder: i18n.t('users.company'),
                    required: true,
                    type: 'text',
                    name: 'company'
                },
                {
                    label: i18n.t('users.job'),
                    placeholder: i18n.t('users.job'),
                    required: true,
                    type: 'text',
                    name: 'job'
                },
                {
                    label: i18n.t('form.website_name'),
                    placeholder: i18n.t('form.website_name'),
                    required: true,
                    type: 'text',
                    name: 'website_title'
                },
                {
                    label: i18n.t('form.website_url'),
                    placeholder: i18n.t('form.website_url'),
                    required: true,
                    type: 'url',
                    name: 'website_url',
                },
                {
                    trackBy: 'title',
                    label: i18n.t('login.wallkit_pricing_plan'),
                    placeholder: i18n.t('login.select_wallkit_pricing_plan'),
                    type: 'select',
                    name: 'pricing_plan',
                    required: true,
                    options: [],
                    loading: false
                }
            ]
        },
        edit: {
            items: [
                {
                    label: i18n.t('form.title'),
                    placeholder: i18n.t('form.title'),
                    required: true,
                    type: 'text',
                    name: 'title'
                },
                {
                    label: i18n.t('form.description'),
                    placeholder: i18n.t('form.description'),
                    required: false,
                    type: 'textarea',
                    name: 'description'
                },
                {
                    label: i18n.t('form.active'),
                    placeholder: i18n.t('form.active'),
                    required: true,
                    type: 'switch',
                    title: i18n.t('global.yes'),
                    titleFalse: i18n.t('global.no'),
                    name: 'active'
                }
            ]
        }
    };

export default fields
